export enum EmailStatusEnum {
	Verified = 'verified',
	Unverified = 'unverified',
	Rejected = 'rejected',
}
